<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
      class="demo-ruleForm login-container">
      <h3 class="title">用户登录</h3>
      <el-form-item prop="username">
        <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="code">
            <el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="图形验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="code-box">
          <img :src="ruleForm.codeimg" alt="" class="codeimg" @click="getcode()">
        </el-col>
      </el-row> -->
      <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',

      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.$message({
      message: '账号密码及验证码不为空即可',
      type: 'success'
    })
    // 获取图形验证码
    this.getcode()
    // 获取存在本地的用户名密码
    this.getuserpwd()

  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      login(this.ruleForm).then(res => {
        console.log("res", res)
        if (res.code == 200) {
          if (this.rememberpwd) {
            //保存帐号到cookie，有效期7天
            setCookie('user', this.ruleForm.username, 7)
            //保存密码到cookie，有效期7天
            setCookie('pwd', this.ruleForm.password, 7)
          } else {
            delCookie('user')
            delCookie('pwd')
          }
          //如果请求成功就让他2秒跳转路由
          setTimeout(() => {
            this.logining = false
            // 缓存token
            localStorage.setItem('logintoken', res.data.token)
            // 缓存用户个人信息
            localStorage.setItem('userdata', JSON.stringify(res.data.info))
            localStorage.setItem('roles', JSON.stringify(res.data.roles))
            this.$store.commit('login', 'true')

            console.log("登录成功",res.data.roles)
            this.menuData()
           
          }, 1000)
        } else {
          this.$message.error(res.msg)
          this.logining = false
          return false
        }
      })

      return;
      this.$refs[formName].validate(valid => {



        // if (valid) {
        //   this.logining = true
        //   // 测试通道，不为空直接登录
        //   setTimeout(() => {
        //     this.logining = false
        //     this.$store.commit('login', 'true')
        //     this.$router.push({ path: '/goods/Goods' })
        //   }, 1000)
        //   // 注释
        //   login(this.ruleForm).then(res => {
        //     if (res.success) {
        //       if (this.rememberpwd) {
        //         //保存帐号到cookie，有效期7天
        //         setCookie('user', this.ruleForm.username, 7)
        //         //保存密码到cookie，有效期7天
        //         setCookie('pwd', this.ruleForm.password, 7)
        //       } else {
        //         delCookie('user')
        //         delCookie('pwd')
        //       }
        //       //如果请求成功就让他2秒跳转路由
        //       setTimeout(() => {
        //         this.logining = false
        //         // 缓存token
        //         localStorage.setItem('logintoken', res.data.token)
        //         // 缓存用户个人信息
        //         localStorage.setItem('userdata', JSON.stringify(res.data))
        //         this.$store.commit('login', 'true')
        //         this.$router.push({ path: '/goods/Goods' })
        //       }, 1000)
        //     } else {
        //       this.$message.error(res.msg)
        //       this.logining = false
        //       return false
        //     }
        //   })
        // } else {
        //   // 获取图形验证码
        //   this.getcode()
        //   this.$message.error('请输入用户名密码！')
        //   this.logining = false
        //   return false
        // }
      })
    },
    // 所有菜单管理 
    menuData() {
      let res = {
        success: true,
        data: [],
        msg: "success"
      };
      var permission = JSON.parse(localStorage.getItem("roles")).permission;
      console.log("permission====", permission);
      if (permission.indexOf("数据管理") != -1) {
        var menus = [];
        if (permission.indexOf("数据管理-数据统计") != -1) {
          menus.push({
            menuid: 941,
            icon: "icon-cat-skuQuery",
            menuname: "数据统计",
            hasThird: "N",
            url: "home/home",
            menus: null
          });
        }
        res.data.push({
          menuid: 1,
          icon: "li-icon-xiangmuguanli",
          menuname: "数据管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("用户管理") != -1) {
        var menus = [];

        if (permission.indexOf("用户管理-用户列表") != -1) {
          menus.push({
            menuid: 11,
            icon: "icon-cat-skuQuery",
            menuname: "用户列表",
            hasThird: "N",
            url: "user/User",
            menus: null
          });
        }

        res.data.push({
          menuid: 2,
          icon: "li-icon-xiangmuguanli",
          menuname: "用户管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("广告管理") != -1) {

        var menus = [];

        if (permission.indexOf("广告管理-开屏广告列表") != -1) {
          menus.push({
            menuid: 171,
            icon: "icon-cat-skuQuery",
            menuname: "广告列表",
            hasThird: "P",
            url: "advertisement/advertisement",
            menus: null
          });
        }
        res.data.push({
          menuid: 17,
          icon: "li-icon-xiangmuguanli",
          menuname: "广告管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("订单管理") != -1) {
        var menus = [];

        if (permission.indexOf("订单管理-商品订单列表") != -1) {
          menus.push({
            menuid: 21,
            icon: "icon-order-manage",
            menuname: "商品订单列表",
            hasThird: "N",
            url: "pay/Order",
            menus: null
          });
        }

        if (permission.indexOf("订单管理-充值记录列表") != -1) {
          menus.push({
            menuid: 233,
            icon: "icon-order-manage",
            menuname: "充值记录列表",
            hasThird: "N",
            url: "pay/payBalance",
            menus: null
          });
        }

        if (permission.indexOf("订单管理-余额明细列表") != -1) {
          menus.push({
            menuid: 234,
            icon: "icon-order-manage",
            menuname: "余额明细列表",
            hasThird: "N",
            url: "pay/walletBalanceDetails",
            menus: null
          });
        }
        if (permission.indexOf("订单管理-为学学院充值记录") != -1) {
          menus.push({
            menuid: 323,
            icon: "icon-cat-skuQuery",
            menuname: "为学学院充值记录",
            hasThird: "P",
            url: "registration_admin/rechargeRecord",
            menus: null
          });
        }
        
        res.data.push({
          menuid: 4,
          icon: "li-icon-xiangmuguanli",
          menuname: "订单管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("商品管理") != -1) {
        var menus = [];

        if (permission.indexOf("商品管理-商品列表") != -1) {
          menus.push({
            menuid: 31,
            icon: "icon-cat-skuQuery",
            menuname: "商品列表",
            hasThird: "N",
            url: "goods/Goods",
            menus: null
          });
        }

        res.data.push({
          menuid: 5,
          icon: "li-icon-xiangmuguanli",
          menuname: "商品列表",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("平台管理") != -1) {
        var menus = [];

        if (permission.indexOf("平台管理-系统用户") != -1) {
          menus.push({
            menuid: 63,
            icon: "icon-cat-skuQuery",
            menuname: "系统用户",
            hasThird: "N",
            url: "terrace/user",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-实名认证") != -1) {
          menus.push({
            menuid: 64,
            icon: "icon-cat-skuQuery",
            menuname: "实名认证",
            hasThird: "N",
            url: "terrace/realName",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-角色管理") != -1) {
          menus.push({
            menuid: 641,
            icon: "icon-cat-skuQuery",
            menuname: "角色管理",
            hasThird: "F",
            url: "terrace/Role",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-评论管理") != -1) {
          menus.push({
            menuid: 65,
            icon: "icon-cat-skuQuery",
            menuname: "评论管理",
            hasThird: "W",
            url: "terrace/Review",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-用户反馈") != -1) {
          menus.push({
            menuid: 66,
            icon: "icon-cat-skuQuery",
            menuname: "用户反馈",
            hasThird: "H",
            url: "terrace/Feedback",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-提现列表") != -1) {
          menus.push({
            menuid: 67,
            icon: "icon-cat-skuQuery",
            menuname: "提现列表",
            hasThird: "H",
            url: "terrace/Withdraw",
            menus: null
          });
        }

        if (permission.indexOf("平台管理-基础设置") != -1) {
          menus.push({
            menuid: 68,
            icon: "icon-cat-skuQuery",
            menuname: "基础设置",
            hasThird: "H",
            url: "terrace/toExamine",
            menus: null
          });
        }
        res.data.push({
          menuid: 6,
          icon: "li-icon-xiangmuguanli",
          menuname: "平台管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("分类管理") != -1) {
        var menus = [];

        if (permission.indexOf("分类管理-分类列表") != -1) {
          menus.push({
            menuid: 71,
            icon: "icon-cat-skuQuery",
            menuname: "分类列表",
            hasThird: "O",
            url: "classification/Classification",
            menus: null
          });
          menus.push({
            menuid: 72,
            icon: "icon-cat-skuQuery",
            menuname: "附近商家",
            hasThird: "O",
            url: "nearbyMerchants/nearbyMerchants",
            menus: null
          });
        }

        res.data.push({
          menuid: 7,
          icon: "li-icon-xiangmuguanli",
          menuname: "分类列表",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("作品管理") != -1) {
        var menus = [];
        if (permission.indexOf("作品管理-作品列表") != -1) {
          menus.push({
            menuid: 81,
            icon: "icon-cat-skuQuery",
            menuname: "作品列表",
            hasThird: "P",
            url: "works/Works",
            menus: null
          });
        }
        res.data.push({
          menuid: 8,
          icon: "li-icon-xiangmuguanli",
          menuname: "作品管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("活动管理") != -1) {
        var menus = [];
        if (permission.indexOf("活动管理-活动列表") != -1) {
          menus.push({
            menuid: 91,
            icon: "icon-cat-skuQuery",
            menuname: "活动列表",
            hasThird: "P",
            url: "activity/Activity",
            menus: null
          });
        }
        res.data.push({
          menuid: 9,
          icon: "li-icon-xiangmuguanli",
          menuname: "活动管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("报名记录") != -1) {
        var menus = [];
        if (permission.indexOf("报名记录") != -1) {
          menus.push({
            menuid: 321,
            icon: "icon-cat-skuQuery",
            menuname: "家教报名记录",
            hasThird: "P",
            url: "registration_admin/tutorRecordList",
            menus: null
          }, {
            menuid: 322,
            icon: "icon-cat-skuQuery",
            menuname: "家长报名记录",
            hasThird: "P",
            url: "registration_admin/parentRecordList",
            menus: null
          });
        }
        res.data.push({
          menuid: 32,
          icon: "li-icon-xiangmuguanli",
          menuname: "报名记录",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("放映厅管理") != -1) {
        var menus = [];
        if (permission.indexOf("放映厅管理-放映厅列表") != -1) {
          menus.push({
            menuid: 101,
            icon: "icon-cat-skuQuery",
            menuname: "放映厅列表",
            hasThird: "P",
            url: "show/ScreenRoom",
            menus: null
          });
        }

        if (permission.indexOf("放映厅管理-放映厅购买列表") != -1) {
          menus.push({
            menuid: 102,
            icon: "icon-cat-skuQuery",
            menuname: "放映厅购买列表",
            hasThird: "P",
            url: "show/RoomBuy",
            menus: null
          });
        }

        res.data.push({
          menuid: 10,
          icon: "li-icon-xiangmuguanli",
          menuname: "放映厅管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("金字塔管理") != -1) {
        var menus = [];
        if (permission.indexOf("金字塔管理-金字塔列表") != -1) {
          menus.push({
            menuid: 111,
            icon: "icon-cat-skuQuery",
            menuname: "金字塔列表",
            hasThird: "P",
            url: "pyram/Pyram",
            menus: null
          });
        }

        res.data.push({
          menuid: 11,
          icon: "li-icon-xiangmuguanli",
          menuname: "金字塔管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("圈层管理") != -1) {
        var menus = [];
        if (permission.indexOf("圈层管理-圈层列表") != -1) {
          menus.push({
            menuid: 121,
            icon: "icon-cat-skuQuery",
            menuname: "圈层列表",
            hasThird: "P",
            url: "circles/Circles",
            menus: null
          });
        }

        if (permission.indexOf("圈层管理-圈层申请列表") != -1) {
          menus.push({
            menuid: 122,
            icon: "icon-cat-skuQuery",
            menuname: "圈层申请列表",
            hasThird: "P",
            url: "circles/Examine",
            menus: null
          });
        }

        res.data.push({
          menuid: 12,
          icon: "li-icon-xiangmuguanli",
          menuname: "圈层管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("课程管理") != -1) {
        var menus = [];
        if (permission.indexOf("课程管理-课程标签列表") != -1) {
          menus.push({
            menuid: 131,
            icon: "icon-cat-skuQuery",
            menuname: "课程标签列表",
            hasThird: "P",
            url: "task/TaskTag",
            menus: null
          });
        }

        if (permission.indexOf("课程管理-用户课程列表") != -1) {
          menus.push({
            menuid: 132,
            icon: "icon-cat-skuQuery",
            menuname: "用户课程列表",
            hasThird: "P",
            url: "task/Task",
            menus: null
          });
        }

        if (permission.indexOf("课程管理-平台课程列表") != -1) {
          menus.push({
            menuid: 133,
            icon: "icon-cat-skuQuery",
            menuname: "平台课程列表",
            hasThird: "P",
            url: "task/taskPlatformTask",
            menus: null
          });
        }

        res.data.push({
          menuid: 13,
          icon: "li-icon-xiangmuguanli",
          menuname: "课程管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("教培机构管理") != -1) {
        var menus = [];
        menus.push({
          menuid: 181,
          icon: "icon-cat-skuQuery",
          menuname: "教培机构列表",
          hasThird: "P",
          url: "institution/institution",
          menus: null
        });

        res.data.push({
          menuid: 18,
          icon: "li-icon-xiangmuguanli",
          menuname: "教培机构管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("商家服务") != -1) {
        var menus = [];
        menus.push({
          menuid: 191,
          icon: "icon-cat-skuQuery",
          menuname: "商家入驻列表",
          hasThird: "P",
          url: "merchant/merchant",
          menus: null
        });

        res.data.push({
          menuid: 19,
          icon: "li-icon-xiangmuguanli",
          menuname: "商家服务",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("自习室管理") != -1) {
        var menus = [];
        menus.push({
          menuid: 201,
          icon: "icon-cat-skuQuery",
          menuname: "自习室列表",
          hasThird: "P",
          url: "room_admin/room_list",
          menus: null
        });

        res.data.push({
          menuid: 20,
          icon: "li-icon-xiangmuguanli",
          menuname: "自习室管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }


      if (permission.indexOf("拉新配置管理") != -1) {
        var menus = [];
        if (permission.indexOf("拉新配置管理-拉新配置列表") != -1) {
          menus.push({
            menuid: 151,
            icon: "icon-cat-skuQuery",
            menuname: "拉新配置列表",
            hasThird: "P",
            url: "laxin/Laxin",
            menus: null
          });
        }
        res.data.push({
          menuid: 15,
          icon: "li-icon-xiangmuguanli",
          menuname: "拉新配置管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }

      if (permission.indexOf("卡密管理") != -1) {

        var menus = [];
        if (permission.indexOf("卡密管理-卡密批次列表") != -1) {
          menus.push({
            menuid: 161,
            icon: "icon-cat-skuQuery",
            menuname: "卡密批次列表",
            hasThird: "P",
            url: "cami/CamiBatch",
            menus: null
          });
        }
        if (permission.indexOf("卡密管理-卡密列表") != -1) {
          menus.push({
            menuid: 162,
            icon: "icon-cat-skuQuery",
            menuname: "卡密列表",
            hasThird: "P",
            url: "cami/Cami",
            menus: null
          });
        }
        res.data.push({
          menuid: 16,
          icon: "li-icon-xiangmuguanli",
          menuname: "卡密管理",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      if (permission.indexOf("字典配置") != -1) {
        var menus = [];

        menus.push({
          menuid: 221,
          icon: "icon-cat-skuQuery",
          menuname: "字典数据",
          hasThird: "O",
          url: "dictConfigure/dictConfigure",
          menus: null
        });

        res.data.push({
          menuid: 22,
          icon: "li-icon-xiangmuguanli",
          menuname: "字典配置",
          hasThird: null,
          url: null,
          menus: menus
        });
      }
      console.log(res.data[0].menus[0].url,'页面跳转路径')
      let newUrl = res.data[0].menus[0].url
      this.$router.push({ path: '/'+newUrl })
    }
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  background-image: url(data:image/svg+xml;base64,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);
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue